<div class="customer-info-form-container">
  <div class="customer-info-form">
    <div class="body">
      <div class="customer-info-form-column">
        <div class="common-form-container">
          <!-- Titre se connecter -->
          <div class="header">
            {{ 'popins.login.title' | translate }}
          </div>

          <!-- Message : créer un compte -->
          <div class="input-row">
            <div class="form-input">
              <span class="label">
                {{ 'popins.login.p1' | translate }}
                <a (click)="subscribe()" class="link">
                  {{ 'popins.login.link2' | translate }}
                </a>
              </span>
            </div>
          </div>

          <!-- Erreur globale (connexion) -->
          <div *ngIf="globalError && !displayForgotPassword" class="error-message">
            {{ globalError }}
          </div>

          <!-- Champ identifiant -->
          <div class="input-row">
            <div class="form-input" [ngClass]="{ error: inputs.login.error }">
              <div class="label-row">
                <span class="label">{{ 'popins.login.label1' | translate }}</span>
              </div>
              <div class="input">
                <div class="p-inputgroup">
                  <input
                    class="text-input sentry-mask"
                    type="text"
                    pInputText
                    [(ngModel)]="inputs.login.value"
                    id="input-login-name"
                    [disabled]="displayForgotPassword"
                    autocorrect="off"
                    spellcheck="false" />
                  <span class="p-inputgroup-addon">
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                  </span>
                </div>
              </div>
              <div *ngIf="inputs.login.error" class="error-message">
                {{ inputs.login.error }}
              </div>
            </div>
          </div>

          <!-- Champ mot de passe -->
          <div class="input-row">
            <div class="form-input" [ngClass]="{ error: inputs.password.error }">
              <div class="label-row">
                <span class="label">{{ 'popins.login.label2' | translate }}</span>
              </div>
              <div class="input">
                <div class="p-inputgroup">
                  <input
                    class="text-input sentry-mask"
                    [type]="showPassword ? 'text' : 'password'"
                    pInputText
                    [(ngModel)]="inputs.password.value"
                    id="input-login-password"
                    [disabled]="displayForgotPassword"
                    autocorrect="off"
                    spellcheck="false" />
                  <span class="p-inputgroup-addon" (click)="togglePasswordVisibility()" style="cursor: pointer">
                    <fa-icon [icon]="showPassword ? faEyeSlash : faEye"></fa-icon>
                  </span>
                </div>
              </div>
              <div *ngIf="inputs.password.error" class="error-message">
                {{ inputs.password.error }}
              </div>
            </div>
          </div>

          <!-- Bouton mot de passe oublié -->
          <div class="input-row">
            <div class="form-input">
              <span class="label">
                <a (click)="displayForgotPassword = !displayForgotPassword" class="link">
                  {{ 'popins.login.link1' | translate }}
                </a>
              </span>
            </div>
          </div>

          <!-- Formulaire mot de passe oublié -->
          <div class="input-row">
            <div class="form-input" *ngIf="displayForgotPassword">
              <div class="label-row">
                <span class="label">{{ 'popins.login.label3' | translate }}</span>
              </div>
              <div class="input">
                <div class="p-inputgroup">
                  <input
                    class="text-input sentry-mask"
                    type="text"
                    pInputText
                    [(ngModel)]="inputs.lostPasswordEmail.value"
                    id="input-forgot-password-email"
                    autocomplete="off"
                    autocorrect="off"
                    spellcheck="false" />
                  <span class="p-inputgroup-addon">
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="footer">
      <div class="actions">
        <ng-casto-button class="secondary" (click)="close()" [label]="'popins.signup.link2' | translate">
        </ng-casto-button>
        <ng-casto-button
          class="primary"
          [loading]="isLoading"
          (click)="submit()"
          [label]="(displayForgotPassword ? 'popins.login.btn2' : 'popins.login.btn') | translate">
        </ng-casto-button>
      </div>
    </div>
  </div>
</div>
